module.exports = __webpack_public_path__ + "static/media/hyundai-headset.8a8e626d.svg";